import { useFetchPaginatedData } from "@hooks/api/useFetchPaginatedData";
import { GetAllProcessos } from "@services/Processo/Index";

export function useFetchDataProcessos() {
    // Usa o hook genérico para buscar todos os processos
    const { data, loading, fetchAllData } = useFetchPaginatedData(GetAllProcessos);
                                                        
    return {
       processosOptions: data.map((item) => ({
           value: item.id,
           label: item.nomeProcesso,
       })).sort((a, b) => a.label.localeCompare(b.label)),
       processosLoading: loading,
       fetchProcessos: fetchAllData,
    };
}
